import { FC } from 'react';
import { Enum } from '..';
import { useConfig } from '../../hooks/config';
import SidebarFooter from '../SidebarFooter';
import Logo from './Logo';
import Text from './Text';

interface iSidebarProps {
  value: any;
  onChange: (val: any) => void;
  formik: any;
  price: number | null;
  error?: string | null;
  onLineHeightChange: (dir: number) => void;
  alignment: string;
  setAlignment: (val: string) => void;
  lineHeight: number;
  type: string;
  setType: (val: string) => void;
  isLoading: boolean;
  label?: string | null;
}

const Sidebar: FC<iSidebarProps> = ({
  value,
  onChange,
  formik,
  price,
  error,
  onLineHeightChange,
  alignment,
  setAlignment,
  lineHeight,
  type,
  setType,
  isLoading,
  label,
}) => {
  const config = useConfig();
  return (
    <>
      <div className='sidebar-wrapper'>
        {window.innerWidth > 500 && !config.isPredefined && (
          <>
            <h1>Create a unique LED neon made with love</h1>
            <Enum
              value={type}
              onChange={setType}
              options={[
                { label: 'Text', value: 'TEXT' },
                { label: 'Logo', value: 'LOGO' },
              ]}
            />
          </>
        )}
        {type === 'LOGO' ? (
          <Logo />
        ) : (
          <Text {...{ lineHeight, value, onChange, formik, onLineHeightChange, alignment, setAlignment }} />
        )}
      </div>
      {type === 'TEXT' && (
        <SidebarFooter isLoading={isLoading} label={label} onSubmit={formik.handleSubmit} price={price} error={error} />
      )}
    </>
  );
};

export default Sidebar;
